import { render, staticRenderFns } from "./PieChartDisplay.html?vue&type=template&id=c49fda08&scoped=true&"
import script from "./PieChartDisplay.js?vue&type=script&lang=js&"
export * from "./PieChartDisplay.js?vue&type=script&lang=js&"
import style0 from "./PieChartDisplay.scss?vue&type=style&index=0&id=c49fda08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c49fda08",
  null
  
)

export default component.exports